import type { CSSProperties, ReactNode } from 'react';
import { type, verdict } from '../theme';

/** The rejection's border: the board's `#F3BCB2`, not `verdict.unknown.border` (`#F3C1B8`). */
const rejectionBorder = '#F3BCB2';

/**
 * `PortalProductForm`'s rejection state, the one error style any board draws.
 * G5 reuses it for a refused distribution write, D10 and D11.
 */
export function Rejection({ children }: { children: ReactNode }) {
  return (
    <div role="alert" style={rejectionBox}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        style={{ flexShrink: 0, marginTop: 1 }}
      >
        <circle cx="12" cy="12" r="9" stroke={verdict.unknown.fg} strokeWidth="1.8" />
        <path d="M12 7.5 V12.5" stroke={verdict.unknown.fg} strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16.2" r="1.2" fill={verdict.unknown.fg} />
      </svg>
      <div
        style={{
          fontFamily: type.caption.fontFamily,
          fontSize: '12.5px',
          color: verdict.unknown.fg,
          lineHeight: 1.5,
        }}
      >
        {children}
      </div>
    </div>
  );
}

const rejectionBox: CSSProperties = {
  borderRadius: 12,
  background: verdict.unknown.bg,
  border: `1px solid ${rejectionBorder}`,
  padding: '12px 14px',
  display: 'flex',
  gap: 10,
  alignItems: 'flex-start',
};
